
import {defineComponent} from 'vue'
import Home from '@/views/Home.vue'


export default defineComponent({
    components: {Home}
    
})
